// extracted by mini-css-extract-plugin
export default {"uploadButton":"SimpleUpload_uploadButton__ho3Zz"};